import { render, staticRenderFns } from "./ListSystemPage.vue?vue&type=template&id=525d1888&"
import script from "./ListSystemPage.vue?vue&type=script&lang=js&"
export * from "./ListSystemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports